module.exports = " <textarea class=form-control v-model=data v-el:textarea v-elastic :placeholder=config.placeholder></textarea> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/TextareaFieldtype.vue
// module id = 763
// module chunks = 0